import { AppContext } from "@Context/common/general/context";
import { useContext } from "react";
import { useCommonProgressData, UseCommonProgressDataReturn } from "./use-common-progress-data";
import { useMobileProgressData, UseMobileProgressDataReturn } from "./use-mobile-progress-data";
import { useVrProgressData, UseVrProgressDataReturn } from "./use-vr-progress-data";

export { MIN_BYB_IQ_FOR_PERFORMANCE_PHASE } from "./use-common-progress-data";

export interface UseProgressDataReturn extends UseCommonProgressDataReturn, Partial<UseVrProgressDataReturn>, Partial<UseMobileProgressDataReturn> {}

export const useProgressData = (): UseProgressDataReturn => {
  const { state } = useContext(AppContext);

  const isMobile = state.device.isMobile;
  const isVR = state.device.isVR && state.device.isUnityEmbedded;

  const commonData = useCommonProgressData();
  const vrData = isVR ? useVrProgressData(commonData) : ({} as UseVrProgressDataReturn);
  const mobileData = isMobile ? useMobileProgressData(commonData) : ({} as UseMobileProgressDataReturn);

  return {
    ...commonData,
    ...vrData,
    ...mobileData,
  };
};
